import { FC, useState } from 'react';
import PropTypes from 'prop-types';
// import toast from 'react-hot-toast';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography
} from '@material-ui/core';

interface StatusReasonDialogProps {
  onClose: () => void;
  onSubmit: (string)=> void;
  open: boolean;
  title: string;
  subtitle?: string;
  placeHolderValue?: string;
  cancelbuttonName?: string;
  submitbuttonName?: string;
}

export const StatusReasonDialog: FC<StatusReasonDialogProps> = (props) => {
  const { open, onClose, title, placeHolderValue, cancelbuttonName,
    submitbuttonName, subtitle, onSubmit } = props;
  const [remark, setRemark] = useState('');

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  const handleClose = (e, reason) => {
    if (reason !== 'backdropClick') {
      setRemark('');
      onClose();
    }
  };

  const handleSubmit = (e, reason) => {
    onSubmit(remark);
    handleClose(e, reason);
    setRemark('');
  };

  return (
    <Dialog
      fullWidth
      onClose={handleClose}
      open={open}
    >
      <DialogTitle>
        {title}
        {subtitle && (
          <Typography
            variant="h6"
            color="gray"
          >
            {subtitle}
          </Typography>
        )}
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
            md={12}
          >
            <TextField
              id="outlined-multiline-static"
              fullWidth
              multiline
              rows={4}
              value={remark}
              onChange={handleRemarkChange}
              placeholder={placeHolderValue || ''}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          onClick={(e) => handleClose(e, '')}
          variant="text"
        >
          {cancelbuttonName || 'Cancel'}
        </Button>
        <Button
          color="primary"
          disabled={!remark}
          onClick={(e) => handleSubmit(e, '')}
          variant="contained"
        >
          {submitbuttonName || 'Submit'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

StatusReasonDialog.defaultProps = {
  open: false
};

StatusReasonDialog.propTypes = {
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  open: PropTypes.bool,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  placeHolderValue: PropTypes.string,
  submitbuttonName: PropTypes.string,
  cancelbuttonName: PropTypes.string,
};
